import { AppStrings } from '../messages';

export const English: AppStrings = {
    or: ' or ',
    max: 'max.',
    accept: 'Accept',
    submit: 'Submit',
    back: 'Back',
    purchase: 'Purchase',
    no_thanks: 'No thanks',
    thank_you: 'Thank you!',
    cancel: 'Cancel',
    close: 'Close',
    click_here_to_get_code: 'Click here to get your code',
    open: 'Open',
    option_unavailable: 'This is currently unavailable',
    confirm: 'Confirm',

    my_trip: 'My trip',
    finalize_trip: 'Finalize your trip',
    trip_all_set: 'Your trip is all set',
    trip_overview_capitalized: 'Trip Overview',
    manage_guests_capitalized: 'Invite Guests',
    manage_guests_title: 'Invite Guests',
    manage_pets_title: 'Add/Remove Dogs',
    manage_pets_error: 'Sorry, an error occurred. To talk with a customer service representative, call 1-800-544-0300',
    add_remove_guest: 'Add or Remove Guest',
    modify_your_trip: 'Modify your trip',
    instructions_for_modify_guests:
        'Let us know how many adults, children (over age 2) will be staying. If your plans aren’t finalized yet, add the guests you know for now—you can come back and update this information later.',
    instructions_for_modify_guests_pets:
        'Let us know how many adults, children (over age 2), and dogs will be staying. If your plans aren’t finalized yet, add the guests you know for now—you can come back and update this information later.',
    instructions_for_modify_pets: 'Furry friends and wagging tails welcome. Add up to {pets} dogs to your stay.',
    instructions_for_modify_pet: 'Furry friends and wagging tails welcome. Add up to 1 dog to your stay.',
    extra_instructions_for_modify_pet: "Changed your mind? We'll refund you any paid pet fees within 5 business days.",
    max_occupancy_modify_guests: 'Max. occupancy is {max_occupancy} {guests}. Additional charges may apply and will be shown below.',
    getting_there: 'Getting there',
    in_the_home: 'In the home',
    features_and_amenities: 'Features & amenities',
    features_and_amenities_capitalized: 'Features & Amenities',
    checkout_instructions: 'Check-out instructions',
    codes_will_be_provided: 'Codes will be provided 1 week before the check in date',
    passwords_will_be_provided: 'Password will be provided 1 week before the check in date',
    alarm_code: 'Alarm code',
    lockbox_code: 'Lockbox code',
    e_lock_codes: 'E-Lock codes',
    gate_access: 'Gate access',
    stay_longer: 'Stay a bit Longer',
    location_and_parking: 'Location & parking',
    on_your_way: 'On your way',
    directions_and_parking_notes: 'Directions & parking',
    directions_to_know: 'Directions to know',
    parking_spaces: 'Parking spaces',
    parking_notes: 'Parking notes',
    entering_home: 'Entering the home',
    home_access_details: 'Home access details',
    house_rules: 'House rules',
    internet_access: 'Internet access',
    network: 'Network',
    password: 'Password',

    reservation: 'Reservation',
    trip_overview: 'Trip overview',
    nights: 'Nights',
    max_occupancy: 'Max. occupancy',
    can_add_guest: 'You can add up to {total} more {guests}',
    can_not_add_guest: 'You’ve reached the maximum number of guests',
    guest: 'Guest',
    guests: 'Guests',
    confirmation: 'Confirmation',
    view_listing: 'View the listing',

    rental_agreement: 'Rental agreement',
    sign_agreement: 'Sign agreement',
    sign_by: 'Review and sign by {signBy}',
    sign_agreement_by: 'Please sign your rental agreement information by {signBy}',
    signed_on: 'Signed on {signedOn}',
    i_agree_terms: 'I agree to the above terms and conditions',
    agreed_on: 'You agreed to these terms on {agreedOn}',
    i_agree_new_terms: `I agree To Vacasa's <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Rental Agreement</a>, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Privacy Policy</a>, and `,
    agreed_new_terms_on: `You agreed to Vacasa's <a  target="_blank" rel="noopener noreferrer" href="{rental_agreement_url}">Rental Agreement</a>, <a  target="_blank" rel="noopener noreferrer" href="{privacy_policy_url}">Privacy Policy</a>, and `,
    agreed_new_terms_on_date: ' on {date}',
    unit_terms_text: 'Unit Specific Terms',
    unit_terms_alert: 'Unless stated otherwise in the ',
    new_terms_required_text: 'Required',
    new_terms_instructions_text: 'Review house rules and confirm agreement below',
    new_terms_submit_btn: 'Submit',
    view_agreement: 'View agreement',
    print_header_text: 'Please follow these instructions. You will be notified once we have received and processed your agreement',
    print_step_one: 'Print, review, and sign this entire agreement',
    print_step_two: 'Return it to us by email or fax',
    print_button: 'Print',
    print_email_label: 'Email',
    print_fax_label: 'Fax',
    print_email_value: 'info@vacasa.com',
    print_fax_value: '(503) 897-7036',
    print_booked_by: 'Booked by',
    print_on: 'on',

    payment_details: 'Payment details',
    make_payment: 'Make a payment',
    pay_balance: 'Pay Balance',
    payment_complete: 'Payment complete',
    pay_by: '{total} due by {payBy}',
    pay_balance_by: 'Pay your balance by {payBy}',
    view_receipt: 'View receipt',

    refund_going_to: 'Refund going to',
    original_payment_methods: 'Original payment method(s)',
    guest_paid: 'Guest paid {amount} on {date}',
    refund_details: 'Refund Details',
    total_refund: 'Total Refund',
    original_payment: 'Original Payment',

    cancellation_charges: 'Cancellation Charges',
    sure_you_want_to_cancel: 'Are you sure you want to cancel your trip?',
    yes_cancel_now: 'Yes, Cancel Now.',
    no_dont_cancel: "No, Don't Cancel.",
    cancel_trip: 'Cancel Trip',
    cancel_and_receive_refund: 'Cancel & Receive Refund',
    view_cancellation_policy: 'View Cancellation Policy',

    vehicle_registration: 'Register vehicles',
    vehicle: 'Vehicle',
    list_your_vehicles: 'Your group’s vehicles',
    register_vehicle: 'Register vehicle',
    max_vehicles_reached: 'Maximum vehicles reached',
    group_has_no_vehicles: 'My group has no vehicles',
    register_by: 'Add all vehicles by {registerBy}',
    register_vehicles_by: 'Please register your vehicles by {registerBy}',
    add_vehicle_info: 'Add vehicle info',
    add_a_vehicle_button: 'Add Vehicle',
    add_vehicle_title: 'Add a vehicle',
    add_vehicle_text: 'Add a vehicle to your trip.',
    vehicle_added: 'Vehicle info added',
    edit_a_vehicle_button: 'Save Changes',
    edit_vehicle_title: 'Edit a vehicle',
    edit_vehicle_text: 'Edit your vehicle information.',
    remove_vehicle_text: 'Remove a vehicle from your trip.',
    remove_vehicle_title: 'Remove a vehicle',
    remove_vehicle_button: 'Remove',
    my_group_has_no_vehicles_title: 'My group has no vehicle',
    my_group_has_no_vehicles_confirm_text:
        'You could be fined by the city or by the HOA if your group brings a vehicle without registering it in advance.',
    my_group_has_no_vehicles_confirm_button: 'Confirm no Vehicles',
    license_plate: 'License plate',
    state_province: 'State / Province',
    other: 'Other',
    location: 'Location',

    add_on: 'Add-on',
    pool_heat: 'Pool heat',
    pool_heat_added: 'Pool heat added',
    pool_heat_add_or_remove: 'Add or Remove Pool heat',
    pool_heat_note: 'Upgrade your stay with our pool heat add-on! Dive into comfort and warmth for every swim.',

    finalize_your_reservation: 'Finalize your reservation',
    these_actions_are_required: 'You must complete these action items to get your check-in details.',

    need_help: 'Need help?',
    visit_our: 'Visit our',
    support_center: 'Support center',
    still_have_questions: 'Still have questions?',
    please_reach: 'Please reach out:',

    home_essentials: 'Home essentials',
    no_beds: 'No beds',
    king_bed: 'king bed',
    king_bed_plural: 'king beds',
    queen_bed: 'queen bed',
    queen_bed_plural: 'queen beds',
    double_bed: 'double bed',
    double_bed_plural: 'double beds',
    twin_bed: 'twin bed',
    twin_bed_plural: 'twin beds',
    child_bed: 'child bed',
    child_bed_plural: 'child beds',
    murphy_bed: 'murphy bed',
    murphy_bed_plural: 'murphy beds',

    no_bathrooms: 'No bathrooms',
    full_bath: 'full bathrooms',
    full_bath_plural: 'full bathrooms',
    half_bath: 'half bathrooms',
    half_bath_plural: 'half bathrooms',

    sleeps: 'Sleeps',

    loading: 'Loading',
    updated_successfully: 'Updated successfully',
    read_more: '...Read more',
    read_less: '...Read less',

    who_is_coming: "Who's coming",
    invite_guest: 'Invite guest',
    invite_guest_note: "Invite your guest and they'll receive a detailed check-in email {daysBefore} days prior to the trip.",
    invite_guest_note_same_day: "Invite your guest and they'll receive a detailed check-in email on the day of arrival.",
    add_guest: 'Invite guests',
    edit_guest: 'Edit guest',
    remove_guest: 'Remove guest',
    edit_guest_note_modal: 'Edit your guests to share the itinerary and access information for this trip.',
    invite_guest_info: 'Add guest info',
    email_addresses_guests: 'Email address',
    modify_guest_note: 'You may add or remove guests from your trip.',
    modify_guest_add_note: 'You may add up to {remainingGuests} more guests',
    need_cancel_trip: 'Need to cancel your trip?',
    need_cancel_note: 'If you need to cancel your trip, please read the conditions here.',
    cancel_trip_options: 'See cancellation options',
    name: 'Name',
    first_name: 'First name',
    last_name: 'Last name',
    email_address: 'Email Address',
    invite_guest_note_modal: 'Add your guests to share itinerary and access information to this trip.',
    yes_remove_invited: 'Yes',
    no_remove_invited: 'Never-mind',
    can_add_pet: 'Add up to {total} furry friend',
    can_add_pets: 'Add up to {total} furry friends',
    can_not_add_pet: 'You’ve reached the maximum number of dogs',
    add_pet_refund_btn: 'Receive Refund',
    add_pet_update_balance_title: 'Update Balance',
    add_pet_checkout_title: 'Continue to Checkout',
    pet: 'Dog',
    pets: 'Dogs',
    remove_invite_note: 'will be removed from the guest list',
    are_you_sure: 'Are you sure?',

    cookie_disclaimer: 'Vacasa uses first- and third-party cookies. By using our sites, you agree to our Cookie Policy.',
    read_cookie_policy: 'Read our Cookie Policy',

    sitemap: 'Sitemap',
    privacy: 'Privacy',
    terms_of_service: 'Terms of Service',

    property_management: 'Vacation Rental Management',
    real_estate: 'Real Estate',
    innovation: 'Innovation',
    company: 'Company',
    about_us: 'About Us',
    blog: 'Blog',
    careers: 'Careers',
    newsroom: 'Newsroom',
    investors: 'Investors',
    community: 'Community',
    social_responsibility: 'Social Responsibility',
    leadership: 'Leadership',
    solutions_partnerships: 'Solutions and Partnerships',
    accessibility: 'Accessibility',
    help: 'Help',
    support_contact: 'Support and Contact',
    toll_free: 'Toll Free:',
    local: 'Local:',
    covid_update: 'COVID-19 Updates',
    hi: 'Hi, ',
    my_trips: 'My Trips',
    favorites: 'Favorites',
    profile: 'Profile',
    logout: 'Log Out',
    owner_login: 'Owner Login',
    owner_portal: 'Homeowner Account',
    login: 'Guest Login / Signup',
    find_my_trip: 'Find My Trip',
    my_account: 'Log In / Sign Up',
    language_and_currency: 'Language',
    an_error_occurred: 'There was an error processing your request',
    somethings_not_right: 'Something is not right',
    something_went_wrong: 'Uh oh, something went wrong',
    error_cancelling: 'There has been an error cancelling your reservation.',
    contact_customer_service: 'Please contact customer service at {phone} for further assistance',
    try_later_or_call: 'Please try later or call your Vacasa representative at',
    reservation_info_unavailable: 'Information Unavailable',

    identity_check_required: 'Identity check is required to continue',
    verify_identity: 'Verify your identity',

    already_completed_idv: 'Already completed?',
    click_here: 'Click here',

    guest_portal_unavailable: 'Trip Manager is not available',
    resolve_issues_calling: 'To resolve this issue, please call your Vacasa representative at',

    session_expired: 'Session expired',
    session_expired_message: 'Session has expired. You are being redirected to',

    access_token_expired: 'Session expired',
    access_token_expired_message: 'Session has expired. You are being redirected to refresh your session.',

    getting_there_capitalized: 'Getting There',
    modify_your_trip_capitalized: 'Modify Your Trip',
    checkout_instructions_capitalized: 'Check-Out Instructions',
    view_receipt_capitalized: 'View Receipt',

    trip_eligibility_trip_already_started:
        'Hooray, your trip has started! If you still need to modify your trip, please call a Vacasa guest representative at',
    trip_eligibility_pending_payment: 'Your payment is currently processing. Check back in 24 hours to modify your trip.',
    trip_eligibility_created_before_june_fourth_2018: 'If you still need to modify your trip, please call a Vacasa guest representative at',
    trip_eligibility_negative_balance: 'Your refund is currently in process. Check back in 24 hours to modify your trip.',
    trip_eligibility_not_allowed_for_occupancy: 'We re sorry, you cannot modify guests/dogs on this reservation.',
    trip_eligibility_refund_in_progress: "You have a refund in progress. Please wait until it's processed to modify your occupancy",

    wheres_my_receipt: 'Where’s my reservation receipt?',
    channel_receipt_note:
        'You made your reservation through one of our booking partners. Please contact the company you booked with to access your receipt and payment information.',

    download_app_mobile_note: 'Trip details, check-in info, & more',
    download_app_mobile_title: 'Get it all in the app',

    payment_title: 'Make a payment',
    receipt_title: 'Receipt',
    addons_title: 'Trip add-ons',
    latecheckout_title: 'Add Late Checkout',
    modify_trip_title: 'Modify Trip',

    submit_guest_edition: 'Submit guest update',
    confirm_guest_remove: 'Confirm remove guest',

    balance_due: 'Balance due',
    balance_in: 'Balance in {currency}',
    total_in: 'Total in {currency}',
    total_with_security_deposit_in: 'Total + Security deposit in {currency}',
    security_deposit: 'Security deposit',
    new_balance_due: 'New Balance in {currency}',
    processed_in_currency_notice:
        'Please note that this transaction was processed in {currency}. Conversion rates are variable approximations.',

    ready_to_checkout: 'Ready to check out?',
    note_early_checkout: 'Click to confirm you’re checking out. This will also notify our housekeeping team that you’ve departed.',
    checkout_now: 'Check Out Now',
    not_ready_yet: 'I’m Not Ready Yet',
    all_set: 'All set!',
    note_confirm_early_checkout: 'Thanks, your check-out is complete. We hope to host you again soon!',
    got_it: 'No problem',
    note_cancel_early_cehckout:
        'You can check out by {checkout}. When you’re ready, click the check-out link again in the text message we sent you.',

    rent: 'Rent',
    fees: 'Fees',
    taxes: 'Taxes',
    trip_protection: 'Trip Protection',
    not_purchased: 'Not Purchased',
    previous_balance: 'Previous Balance',
    sub_total: 'Sub-total',
    pet_refund: 'Dog Refund',
    adult_added: 'Adult added',
    adults_added: 'Adults added',
    pet_added: 'Dog added',
    pets_added: 'Dogs added',
    child_added: 'Child added',
    children_added: 'Children added',
    child: 'Child',
    children: 'Children',

    payment_processed_by: 'Payment processed by:',
    billing_address: 'Billing Address:',

    receipt_thirty_party_channel: 'Thank you for booking your Vacasa home through {channel}',

    covid19_text: 'An update on coronavirus (COVID-19) and our cancellation policies',
    covid19_button_text: 'Read Our Latest Updates',
    covid19_link: 'https://www.vacasa.com/support/coronavirus-covid-19',

    square_feet: 'square feet',

    browser_deprecated: 'Browser not supported',
    please_upgrade_browser: 'Please upgrade or use another browser to view this site',

    know_before_you_go: 'Know before you go',
    import_details: 'Important Details',
    directions_and_parking_details: 'Directions and parking details',
    note_for_our_guests: 'Notes for our guests',

    cannot_perform_action_title: 'This page is not available right now',
    cannot_perform_action_message: 'Please try later or call your Vacasa representative at',

    fsc_credits: 'Future Stay Credits',

    address: 'Address',

    cancel_trip_title: 'Cancel Your Trip',
    cancel_your_reservation: 'Cancel your Reservation',

    payment_form_add_night: 'Add a night',
    payment_form_add_night_note: 'Your new check-out time will be',
    payment_form_pricing_details: 'Pricing Details',
    payment_form_pricing_discounted_rent: 'Discounted Rent',
    payment_form_pricing_discount: 'Discount',
    payment_form_total: 'Total',
    payment_form_billing_information: 'Billing Information',
    payment_form_billing_name: 'Billing Name',
    payment_form_country: 'Country',
    payment_form_city: 'City',
    payment_form_island: 'Island',
    payment_form_postal_code: 'Postal Code',
    payment_form_province: 'Province',
    payment_form_department: 'Department',
    payment_form_city_or_town: 'City/Town',
    payment_form_area: 'Area',
    payment_form_region: 'Region',
    payment_form_parish: 'Parish',
    payment_form_prefecture: 'Prefecture',
    payment_form_emirate: 'Emirate',
    payment_form_county: 'County',
    payment_form_state: 'State',
    payment_form_governorate: 'Governorate',
    payment_form_zip_code: 'ZIP Code',
    payment_form_card_number: 'Card Number',
    payment_form_expiration_date: 'Expiration Date',
    payment_form_expiration_month: 'Expiration Month',
    payment_form_expiration_year: 'Expiration Year',
    payment_form_security_code: 'Security Code',
    payment_form_payments_note: 'We accept most major credit cards',
    payment_form_pay_now: 'Pay Now',
    payment_form_visa: 'Visa',
    payment_form_master_card: 'Master',
    payment_form_discover: 'Discover',
    payment_form_reservation_details: 'Reservation Details',
    payment_form_adult: 'Adult',
    payment_form_adults: 'Adults',
    payment_form_child: 'Child',
    payment_form_children: 'Children',
    payment_form_month: 'Month',
    payment_form_year: 'Year',
    payment_successful: 'All set!',
    payment_successful_note:
        'Enjoy that extra night of vacation. Below you’ll find your payment details—and check your inbox for a confirmation email with your new trip dates.',
    payment_failed: "We couldn't process your payment",
    payment_call_us_to_complete: 'Don’t worry—for now, we’re holding the extra night for you.',
    payment_call_us_to_complete_start: 'Call',
    payment_call_us_to_complete_end: 'to pay via phone and confirm the change to your trip.',
    payment_form_removed: 'Removed',
    payment_form_added: 'Added',
    payment_successful_generic_note: 'Your trip is updated. Here’s your payment confirmation.',
    payment_trip_paid_in_full: 'Your trip is paid in full.',
    payment_successful_add_pet_adjustment_note:
        "You've added {total} {pet} to your stay. Let the tail wagging begin. Here's your payment confirmation.",
    payment_successful_add_pet_adjustment_refund_note:
        "You've removed {total} {pet} from your stay. We'll refund you any paid pet fees within 5 business days.",
    payment_successful_add_pool_heat_adjustment_note: "You've added pool heat to your stay. Here's your payment confirmation.",

    modal_adjustment_not_available_continue: 'Continue',
    modal_adjustment_not_available_back_to_trip: 'Back to Trip Details',
    modal_adjustment_not_available_title: 'This night is no longer available',
    modal_adjustment_not_available_note_start:
        'Sorry, we can’t add the extra night to your trip. (Another guest already booked it, or the deal expired.)',
    modal_adjustment_not_available_note_end: 'We hope you still have a great stay!',

    modal_lco_adjustment_not_available_title: 'Late checkout not available',
    modal_lco_adjustment_not_available_note_start: 'Sorry, we can’t add late checkout to your stay.',
    modal_lco_adjustment_pending_balance_note_start: 'Before adding late checkout, you’ll need to pay the current balance for your trip.',

    modal_adjustment_pending_balance_title: 'Pay your balance to unlock this deal',
    modal_adjustment_pending_balance_note_start: 'Before adding a night, you’ll need to pay the current balance for your trip.',
    modal_adjustment_pending_balance_note_end: 'Once you’ve paid, you can go back to your email and try again.',

    night_added: 'night added',
    nights_added: 'nights added',

    maintenance_window_title: 'This page is under maintenance',
    maintenance_window_note: 'We will be live again very soon. Thanks for you patience',
    maintenance_go_to_home: 'Go to Homepage',
    maintenance_link: 'https://www.vacasa.com',

    modal_cancel_go_to_my_trips: 'Go to My Trips',
    modal_cancel_title: 'Canceled reservation',
    modal_cancel_note: 'Your reservation has been successfully canceled',

    billing_information_note: 'Please review your changes and confirm to complete you trip updates.',

    adjustment_failed_title: "We couldn't modify your trip",

    whats_nearby: "What's nearby",
    whats_nearby_capitalized: "What's Nearby",
    checkout_best_of_city:
        "Check out the best of {unitCity} while you're here. Explore popular restaurants, attractions, and more around {unitName}.",

    banking: 'Banking',
    restaurants_and_coffee: 'Restaurants & Coffee',
    groceries: 'Groceries',
    hospitals: 'Hospitals',
    movie_theaters: 'Movie Theaters',
    bars_and_nightlife: 'Bars & Nightlife',
    parks: 'Parks',
    pharmacies: 'Pharmacies',
    shopping: 'Shopping',
    sports: 'Sports',
    universities: 'Universities',
    tourist_attractions: 'Tourist Attractions',
    filter_by_category: 'Filter by category',

    star_rating_title: 'Review your stay',
    star_rating_note: 'How was your experience at {unitName}? Your feedback is important to us.',
    next: 'Next',

    pay_balance_issue: 'Call {phone} to pay and confirm the change to your trip.',

    chat_default_message: 'Hi, how can we help you today?',
    chat_default_name: 'Vacasa Customer Service',
    chat_start_new_button: 'Start New Chat',
    chat_start_content: 'Thanks for chatting with us!',
    chat_open: 'Live chat is available',
    chat_message_close:
        'Unfortunately you have reached us outside of live chat hours. For immediate assistance please call our 24-hour support line.',
    chat_rule_close: '{openTime} to {closeTime}.',
    chat_rule: 'daily from {openTime} to {closeTime}.',
    chat_error: 'Error Initializing Chat',
    chat_loading: 'loading...',
    chat_me: 'Me',

    extended_stay_capitalized: 'Extend My Stay',
    extended_stay_rules: 'Select up to 4 additional nights before or after your scheduled trip to extend your stay.',
    extended_stay_success_alert_plural: '<b>{numberNights} nights</b> added to your itinerary for <b>{price}</b>',
    extended_stay_success_alert: '<b>1 night</b> added to your itinerary for <b>{price}</b>',
    extended_stay_error_message: 'Sorry, an error occurred. To talk with a customer service representative, call 1-800-544-0300',
    extended_stay_note_message: 'Your new check-in and check-out dates will be',
    check_in: 'Check in',
    check_in_description: 'Earlier available check in dates:',
    check_out: 'Check out',
    adult: 'Adult',
    adults: 'Adults',
    check_out_description: 'Later available check out dates:',
    empty_calendar_before_options: '* Unfortunately all dates before your trip are unavailable',
    empty_calendar_after_options: '* Unfortunately all dates after your trip are unavailable',
    payment_form_add_extended_stay: '{days} Additional Nights',
    today: 'Today',
    clear: 'Clear',
    checkout: 'Checkout',
    reset_dates: 'Reset Dates',
    total_cost: 'Total Cost',

    late_check_out_capitalized: 'Add Late Checkout',
    payment_form_add_late_check_out_note: 'Your new check-out time will be',
    payment_form_add_late_check_out: 'Late Check-Out Added',

    bedroom_title: 'Sleeping Arrangements',
    view_all_beds: 'View all {total} sleeping arrangements',
    view_less: 'View Less',
    view_more: 'View More',

    pool_heat_capitalized: 'Add Pool Heat',

    pal_res_question_panel_text: 'This property is managed by {name}. For support, please email {email} or call {phoneNumber}.',
    pal_res_question_panel_text_email_only: 'This property is managed by {name}. For support, please email {email}.',
    pal_res_question_panel_text_phone_only: 'This property is managed by {name}. For support, call {phoneNumber}.',

    pal_cancellation_contact_text:
        'To request a cancellation, please contact {name} by sending an email to {email} or by calling {phoneNumber}.',
    pal_cancellation_contact_text_email_only: 'To request a cancellation, please contact {name} by sending an email to {email}.',
    pal_cancellation_contact_text_phone_only: 'To request a cancellation, please contact {name} by calling {phoneNumber}.',

    pal_agreement_details_house_rules_text: 'Please take a moment to review the house rules below. They apply to your stay at this home.',
    rental_terms: 'Rental terms',
    view_terms: 'View terms',
    request_cancellation: 'Request Cancellation',
    review_cancellation_policy: 'Review Cancellation Policy',
    pricing_details: 'Pricing Details',
    view_details: 'View details',
};
